export { isAgentCapabilities as validSessionCapabilities } from '@borgee/agent-remote-protocol';
function canonical(value) {
    if (value === null || typeof value !== 'object')
        return value;
    return Object.fromEntries(Object.entries(value).filter(([, entry]) => entry !== undefined).sort(([a], [b]) => a.localeCompare(b)).map(([key, entry]) => [key, canonical(entry)]));
}
export function sameSessionCapabilities(left, right) {
    return JSON.stringify(canonical(left)) === JSON.stringify(canonical(right));
}
//# sourceMappingURL=normalized-session-capabilities.js.map